<template>
  <div class="logo-container">
    <div class="logo" :style="{'font-size': fontsize}">
      <div id="logo-title" class="logo-title">
        <div>YAM</div>
        <div>YAM</div>
      </div>
      <!-- <div id="logo-bullets" class="logo-bullets" v-show="!scrolled"> -->
      <div id="logo-bullets" class="logo-bullets">
        <template v-for="(bulletpoint, index) in bullets">
          <div
            class="logo-bulletpoint"
            :key="'bullet-' + index"
          >
            {{ bulletpoint.text }}
          </div>
          <div class="logo-bulletpoint-spacer" :key="'spacer-' + index" v-if="index < bullets.length - 1">&middot;</div>
        </template>
      </div>
    </div>
    <!-- <div>{{bulletMaxSize}}</div> -->
  </div>
</template>

<script>
export default {
  name: 'navbar',
  props: ['scrolled'],
  data: function () {
    return {
      currentBulletsize: 0.0,
      showBullets: true,
      bullets: [
        {
          name: 'sushi',
          text: 'sushi',
          href: 'sushi',
        },
        {
          name: 'restaurant',
          text: 'restaurant',
          // text: 'vietnamesische spezialitäten',
          href: 'menu',
        },
        {
          name: 'bar',
          text: 'bar',
          href: 'bar',
        },
      ],
    }
  },
  computed: {
    mobile() {
      return window.innerWidth < 500
    },
    fontsize() {
      return this.mobile ? '2em' : '3em'
    },
    bulletTargetWidth() {
      var element = document.getElementById('logo-title')
      if (!element) return 0
      // console.log(element.offsetWidth)
      return element.offsetWidth
    },
    bulletWidth() {
      var element = document.getElementById('logo-bullets')
      if (!element) return 0
      return element.offsetWidth
    },

    bulletsize() {
      return this.currentBulletsize + 'px'
    },
  },
  methods: {
  },
}
</script>

<style lang="scss" scoped>
@import "@/style/settings.scss";

$transition-duration-shrink: 2s;
$transition-duration-expand: 3s;
$bullet-point-size: 0.35em;
$bullet-point-line-height: .45em;

.logo-container {
  position: relative;
  // overflow: visible;
  width: auto;
  margin: auto;
  // transition: width 3s;

  .logo {
    // height: 100%;
    position: relative;
    display:inline-block;
    // width: 100%;
    z-index: 3;
    line-height: .8em;
    text-transform: uppercase;
    user-select: none;
    // @media (min-width: $media-m) {
    //   font-size: 3.5em;
    // }
    // @media (max-width: $media-s) {
    //   font-size: 2.5em;
    // }

    &:after {
      background-image: url("/logo.svg");
      content: "";
      background-size: contain;
      background-position: calc(50% + 7px) top;
      background-repeat: no-repeat;
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      z-index: 2;
    }
    // background-position: center 10px top 0px;
    // background-repeat: no-repeat;

    > * {
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      justify-content: space-between;
      align-items: stretch;
      align-content: stretch;
    }

    .logo-title {
      margin-bottom: 5px;

      > * {
        text-align: center;
        margin-right: .8em;
        &:first-child {
          text-align: left;
        }
        &:last-child {
          text-align: right;
          margin-right: 0;
        }
      }
    }

    .logo-bullets {
      // display: inline-block;
      z-index: 4;
      font-size: $bullet-point-size;
      position: relative;
      text-align: center;
      .logo-bulletpoint {
        line-height: 1em;
        // display: inline-block;
      }
      .logo-bulletpoint-spacer {
        // display: inline-block;
        line-height: 1em;
        text-align: center;
        font-weight: bold;
        color: $highlight-color;
        margin: 0 .5em;
      }
    }
  }

  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s, max-height 3s;
    transition-timing-function: ease-in;
  }
  .fade-enter, .fade-leave-to {
    opacity: 0;
    max-height: auto;
  }

  .height-enter-active, .height-leave-active {
    // max-height: 5000px;
    // ransform: scaleY(1);
    height: $bullet-point-line-height;
    overflow: hidden;
    transition:
      font-size $transition-duration-expand*0.5 $ease-out-expo,
      height $transition-duration-expand*0.2 $transition-duration-expand*.2 ease-out,
      opacity $transition-duration-expand*0.3 $transition-duration-expand*.4 ease-out;
    // transition-timing-function: ease-out;
  }
  .height-enter, .height-leave-to {
    opacity: 0;
    // font-size: 0 !important;
    height: 0;
    transition:
      opacity $transition-duration-shrink*0.1 ease-in,
      height $transition-duration-shrink*0.3 ease-in,
      font-size $transition-duration-shrink*0.5 $transition-duration-shrink*0.5 $ease-in-expo;
    // transition:
    //   font-size $transition-duration*0.7 $ease-in-expo,
    //   opacity $transition-duration*0.3 $transition-duration*0.7;
    // transform: scaleY(0);
    // max-height: 0;
    // opacity: 0;
    // transition: max-width 5s;
    // transition: max-height 1s;
    // overflow: visible;
  }
}

</style>
